//Libs
import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
//Services
import { auth } from "../../Services/Database/Firebase.service";
import { createNewUser, createUserDoc } from "../../Services/User/CreateNewUser.service";
//Contexts
import { useAuth } from "../../Contexts/AuthContext/useAuth.context";
//Hooks
import useSwalToast from "../../Hooks/useSwalToast";
//Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
//Style
import "./Style/Register.css";

const Register = () => {
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { showToast } = useSwalToast();
    const { prevUserCredentials } = useAuth();
    
    const handleSignUp = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true)
        if (!name || !email || !password) {
            showToast('warning', 'Por favor, preencha todos os campos.');
            return;
        }
        
        try {
            const user = await createNewUser(email, password);
            if(!user){
                throw new Error('Erro ao cadastrar usuario.');
            }
    
            await createUserDoc(name, user, 'User');
            if(prevUserCredentials){
                await signInWithEmailAndPassword(auth, prevUserCredentials.email, prevUserCredentials.password);
            }
            showToast('success', "Usuario cadastrado com sucesso!");
        } catch (error) {
            console.error(`Error at register: ${error}`);
            showToast('error', (error as Error).message);
        }finally {
            setName("");
            setEmail("");
            setPassword("");
            setIsLoading(false);
        }
    }

    return (
        <form className="form" id="register" onSubmit={handleSignUp}> 
            <header className="form-header">
                <div className="header-title">
                    <h2>Cadastrar Usuario</h2>
                    <small>Preencha os campos abaixo e clique em salvar para adicionar um novo usuario.</small>
                </div>
            </header>
            <fieldset className="form-group">
                <label className="form-label">
                    <p className="input-label">Nome Completo</p>
                    <input 
                        className="form-input" 
                        type="text"
                        placeholder="Example"
                        value={name}
                        onChange={(e)=> setName(e.target.value)} 
                        />
                </label>
                <label className="form-label">
                    <p className="input-label">E-mail</p>
                    <input
                        className="form-input"
                        type="email"
                        placeholder="example@macrolub.com.br"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </label>
                <label className="form-label">
                    <p className="input-label">
                        Senha
                    </p>
                    <input
                        className="form-input"
                        type="password"
                        placeholder="************"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </label>
            </fieldset>
            <button type='submit' className="button success" id="form-submit-button">
                {isLoading && <FontAwesomeIcon icon={faSpinner} spin />}
                {!isLoading && <p>Salvar</p>}
            </button>
            
        </form>
    )
}

export default Register